interface FooterProps {
  logoWhite: string
  labels: {
    brand: string
    about_us: string
    contact: string
    help_legal: string
    returns: string
    privacy: string
    terms: string
    socials: string
  }
  urls: {
    about: string
    contact: string
    returns: string
    confidentiality: string
    cgv: string
    instagram: string
  }
}

export default function Footer({ logoWhite, labels, urls }: FooterProps) {
  return (
    <>
      <section className="bg-black py-16 md:py-24">
        <div className="flex justify-center items-center">
          <img src={logoWhite} alt="UNSF" className="h-24 md:h-32" />
        </div>
      </section>

      <footer className="bg-white pt-12 pb-8 font-unsf-title">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-bold text-black mb-10">
                {labels.brand}
              </h4>
              <ul className="space-y-8">
                <li>
                  <a
                    href={urls.about}
                    className="text-sm text-gray-600 hover:text-black transition-colors"
                  >
                    {labels.about_us}
                  </a>
                </li>
                <li>
                  <a
                    href={urls.contact}
                    className="text-sm text-gray-600 hover:text-black transition-colors"
                  >
                    {labels.contact}
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-black mb-10">
                {labels.help_legal}
              </h4>
              <ul className="space-y-8">
                <li>
                  <a
                    href={urls.returns}
                    className="text-sm text-gray-600 hover:text-black transition-colors"
                  >
                    {labels.returns}
                  </a>
                </li>
                <li>
                  <a
                    href={urls.confidentiality}
                    className="text-sm text-gray-600 hover:text-black transition-colors"
                  >
                    {labels.privacy}
                  </a>
                </li>
                <li>
                  <a
                    href={urls.cgv}
                    className="text-sm text-gray-600 hover:text-black transition-colors"
                  >
                    {labels.terms}
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-black mb-10">
                {labels.socials}
              </h4>
              <ul className="space-y-8">
                <li>
                  <a
                    href={urls.instagram}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm text-gray-600 hover:text-black transition-colors"
                  >
                    Instagram
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
